// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sora角色创建节点样式 */
.SoraRoleCreateNode-container {
  position: relative;
  background: white;
  border: 2px solid #ddd;
  border-radius: 12px;
  padding: 16px;
  min-width: 320px;
  max-width: 380px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.SoraRoleCreateNode-title {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: monospace;
}

.SoraRoleCreateNode-wrapper {
  /* 内容区域 */
}

/* 信息展示区域 */
.SoraRoleCreateNode-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.SoraRoleCreateNode-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.SoraRoleCreateNode-info-row:last-child {
  margin-bottom: 0;
}

.SoraRoleCreateNode-info-label {
  font-size: 12px;
  font-weight: 600;
  color: #666;
}

.SoraRoleCreateNode-info-value {
  font-size: 12px;
  color: #333;
  font-family: monospace;
}

/* 状态徽章 */
.SoraRoleCreateNode-status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.SoraRoleCreateNode-status-draft {
  background: #e2e8f0;
  color: #64748b;
}

.SoraRoleCreateNode-status-pending {
  background: #fef3c7;
  color: #d97706;
}

.SoraRoleCreateNode-status-processing {
  background: #dbeafe;
  color: #2563eb;
}

.SoraRoleCreateNode-status-completed {
  background: #d1fae5;
  color: #059669;
}

.SoraRoleCreateNode-status-failed {
  background: #fee2e2;
  color: #dc2626;
}

/* 表单字段 */
.SoraRoleCreateNode-field {
  margin-bottom: 12px;
}

.SoraRoleCreateNode-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.SoraRoleCreateNode-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}

.SoraRoleCreateNode-input:focus {
  outline: none;
  border-color: #3b82f6;
}

.SoraRoleCreateNode-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.SoraRoleCreateNode-textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.2s ease;
}

.SoraRoleCreateNode-textarea:focus {
  outline: none;
  border-color: #3b82f6;
}

.SoraRoleCreateNode-textarea:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.SoraRoleCreateNode-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.SoraRoleCreateNode-select:focus {
  outline: none;
  border-color: #3b82f6;
}

.SoraRoleCreateNode-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* 按钮组 */
.SoraRoleCreateNode-button-group {
  display: flex;
  gap: 8px;
}

.SoraRoleCreateNode-button {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #333;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.SoraRoleCreateNode-button:hover:not(:disabled) {
  border-color: #3b82f6;
  color: #3b82f6;
}

.SoraRoleCreateNode-button-active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.SoraRoleCreateNode-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 操作按钮区域 */
.SoraRoleCreateNode-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.SoraRoleCreateNode-action-button {
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.SoraRoleCreateNode-create-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.SoraRoleCreateNode-create-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.SoraRoleCreateNode-train-button {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.SoraRoleCreateNode-train-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(240, 147, 251, 0.4);
}

.SoraRoleCreateNode-query-button {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
}

.SoraRoleCreateNode-query-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(79, 172, 254, 0.4);
}

.SoraRoleCreateNode-copy-button {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
}

.SoraRoleCreateNode-copy-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(67, 233, 123, 0.4);
}

.SoraRoleCreateNode-copy-button i {
  margin-right: 4px;
}

.SoraRoleCreateNode-action-button:active:not(:disabled) {
  transform: translateY(0);
}

.SoraRoleCreateNode-button-disabled {
  background: #ccc !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* 错误提示 */
.SoraRoleCreateNode-error {
  padding: 8px 12px;
  background-color: #fee;
  color: #c33;
  border-radius: 6px;
  font-size: 12px;
  margin-bottom: 8px;
  word-break: break-word;
}

/* 使用说明 */
.SoraRoleCreateNode-hint {
  font-size: 11px;
  color: #999;
  line-height: 1.4;
}

/* Handle 样式 */
.SoraRoleCreateNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.SoraRoleCreateNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

.SoraRoleCreateNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.SoraRoleCreateNode-handle-video {
  border-color: #ed64a6;
  background: #ed64a6;
}

/* Handle 标签 */
.SoraRoleCreateNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

/* 悬停时显示标签 */
.SoraRoleCreateNode-handle:hover .SoraRoleCreateNode-handle-label {
  opacity: 1;
}

/* 节点被选中时显示标签 */
.react-flow__node.selected .SoraRoleCreateNode-handle .SoraRoleCreateNode-handle-label {
  opacity: 1;
}

/* 复制按钮 */
.SoraRoleCreateNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.SoraRoleCreateNode-container:hover .SoraRoleCreateNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.SoraRoleCreateNode-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/SoraRoleCreateNode.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":["/* Sora角色创建节点样式 */\n.SoraRoleCreateNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #ddd;\n  border-radius: 12px;\n  padding: 16px;\n  min-width: 320px;\n  max-width: 380px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.SoraRoleCreateNode-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-family: monospace;\n}\n\n.SoraRoleCreateNode-wrapper {\n  /* 内容区域 */\n}\n\n/* 信息展示区域 */\n.SoraRoleCreateNode-info {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 12px;\n}\n\n.SoraRoleCreateNode-info-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.SoraRoleCreateNode-info-row:last-child {\n  margin-bottom: 0;\n}\n\n.SoraRoleCreateNode-info-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n}\n\n.SoraRoleCreateNode-info-value {\n  font-size: 12px;\n  color: #333;\n  font-family: monospace;\n}\n\n/* 状态徽章 */\n.SoraRoleCreateNode-status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.SoraRoleCreateNode-status-draft {\n  background: #e2e8f0;\n  color: #64748b;\n}\n\n.SoraRoleCreateNode-status-pending {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.SoraRoleCreateNode-status-processing {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.SoraRoleCreateNode-status-completed {\n  background: #d1fae5;\n  color: #059669;\n}\n\n.SoraRoleCreateNode-status-failed {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* 表单字段 */\n.SoraRoleCreateNode-field {\n  margin-bottom: 12px;\n}\n\n.SoraRoleCreateNode-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 6px;\n}\n\n.SoraRoleCreateNode-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n}\n\n.SoraRoleCreateNode-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n.SoraRoleCreateNode-input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.SoraRoleCreateNode-textarea {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  resize: vertical;\n  font-family: inherit;\n  transition: border-color 0.2s ease;\n}\n\n.SoraRoleCreateNode-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n.SoraRoleCreateNode-textarea:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.SoraRoleCreateNode-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.SoraRoleCreateNode-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n.SoraRoleCreateNode-select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n/* 按钮组 */\n.SoraRoleCreateNode-button-group {\n  display: flex;\n  gap: 8px;\n}\n\n.SoraRoleCreateNode-button {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #333;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.SoraRoleCreateNode-button:hover:not(:disabled) {\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n\n.SoraRoleCreateNode-button-active {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n.SoraRoleCreateNode-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* 操作按钮区域 */\n.SoraRoleCreateNode-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.SoraRoleCreateNode-action-button {\n  width: 100%;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.SoraRoleCreateNode-create-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.SoraRoleCreateNode-create-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.SoraRoleCreateNode-train-button {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n}\n\n.SoraRoleCreateNode-train-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(240, 147, 251, 0.4);\n}\n\n.SoraRoleCreateNode-query-button {\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n  color: white;\n}\n\n.SoraRoleCreateNode-query-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(79, 172, 254, 0.4);\n}\n\n.SoraRoleCreateNode-copy-button {\n  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n  color: white;\n}\n\n.SoraRoleCreateNode-copy-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(67, 233, 123, 0.4);\n}\n\n.SoraRoleCreateNode-copy-button i {\n  margin-right: 4px;\n}\n\n.SoraRoleCreateNode-action-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.SoraRoleCreateNode-button-disabled {\n  background: #ccc !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* 错误提示 */\n.SoraRoleCreateNode-error {\n  padding: 8px 12px;\n  background-color: #fee;\n  color: #c33;\n  border-radius: 6px;\n  font-size: 12px;\n  margin-bottom: 8px;\n  word-break: break-word;\n}\n\n/* 使用说明 */\n.SoraRoleCreateNode-hint {\n  font-size: 11px;\n  color: #999;\n  line-height: 1.4;\n}\n\n/* Handle 样式 */\n.SoraRoleCreateNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.SoraRoleCreateNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n.SoraRoleCreateNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.SoraRoleCreateNode-handle-video {\n  border-color: #ed64a6;\n  background: #ed64a6;\n}\n\n/* Handle 标签 */\n.SoraRoleCreateNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.75);\n  color: white;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n/* 悬停时显示标签 */\n.SoraRoleCreateNode-handle:hover .SoraRoleCreateNode-handle-label {\n  opacity: 1;\n}\n\n/* 节点被选中时显示标签 */\n.react-flow__node.selected .SoraRoleCreateNode-handle .SoraRoleCreateNode-handle-label {\n  opacity: 1;\n}\n\n/* 复制按钮 */\n.SoraRoleCreateNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.SoraRoleCreateNode-container:hover .SoraRoleCreateNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.SoraRoleCreateNode-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
